import { fetcher } from '#lib/backendFetcher';

/**
 * Starts AI email generation for a campaign.
 * @param {string} campaignId - UUID of the campaign
 * @returns {Promise<{success: boolean, jobId: string, campaignId: string, message: string}>}
 */
export const generateAICampaign = async (campaignId) => {
	return fetcher(`/api/v1/email/campaigns/ai/${campaignId}/generate`, {
		method: 'POST',
	});
};

/**
 * Fetches the generation status of a campaign.
 * @param {string} campaignId - UUID of the campaign
 * @returns {Promise<{campaignId: string, status: string, approved: boolean, jobStatus: Object, stats: Object}>}
 */
export const getGenerationStatus = async (campaignId) => {
	return fetcher(`/api/v1/email/campaigns/ai/${campaignId}/status`);
};

/**
 * Regenerates a single AI-generated email.
 * @param {string} emailId - UUID of the generated email
 * @returns {Promise<{success: boolean, emailId: string, subject: string, content: string}>}
 */
export const regenerateEmail = async (emailId) => {
	return fetcher(`/api/v1/email/campaigns/ai/emails/${emailId}/regenerate`, {
		method: 'POST',
	});
};

/**
 * Fetches contacts for which no emails have been generated yet.
 * @param {string} campaignId - UUID of the campaign
 * @returns {Promise<{count: number, contactIds: Array<string>}>}
 */
export const getPendingContacts = async (campaignId) => {
	return fetcher(`/api/v1/email/campaigns/ai/${campaignId}/pending-contacts`);
};

/**
 * Generates emails only for pending contacts (incremental).
 * @param {string} campaignId - UUID of the campaign
 * @returns {Promise<{success: boolean, jobId: string, pendingCount: number, message: string}>}
 */
export const generatePendingEmails = async (campaignId) => {
	return fetcher(`/api/v1/email/campaigns/ai/${campaignId}/generate-pending`, {
		method: 'POST',
	});
};

/**
 * Cancels an ongoing AI email generation (already generated emails are retained).
 * @param {string} campaignId - UUID of the campaign
 * @returns {Promise<{success: boolean, message: string, generatedCount: number}>}
 */
export const cancelAICampaignGeneration = async (campaignId) => {
	return fetcher(`/api/v1/email/campaigns/ai/${campaignId}/cancel`, {
		method: 'POST',
	});
};
